import { Injectable } from '@angular/core';
import { ColorConstants } from '../../_models/color-constants';
import { GlobalSharedService } from './global-shared.service';

@Injectable({
  providedIn: 'root'
})
export class LabelService {

  readonly kidsLabel = [
    {character: 'K', color: ColorConstants.ORIGINAL_CHART_COLORS[1]},
    {character: 'i', color: ColorConstants.ORIGINAL_CHART_COLORS[4]},
    {character: 'd', color: ColorConstants.ORIGINAL_CHART_COLORS[3]},
    {
      character: 's', color: ColorConstants.ORIGINAL_CHART_COLORS[5]
    }];

  readonly proLabel = [{character: 'P', color: ColorConstants.METAL}, {character: 'R', color: ColorConstants.METAL}, {
    character: 'O',
    color: ColorConstants.METAL
  }];

  constructor(private sharedService: GlobalSharedService) {
  }

  getLabelSuffix(): string {
    if (this.sharedService.isKidsAccount()) {
      return '_KIDS';
    } else if (this.sharedService.isProAccount()) {
      return '_PRO';
    }
    return ''; // default: SCHOOL type
  }

  getAccountType(): { character: string, color: string } [] {
    if (this.sharedService.isKidsAccount()) {
      return this.kidsLabel;
    } else if (this.sharedService.isProAccount()) {
      return this.proLabel;
    }
    return []; // default: SCHOOL type
  }
}
